import {
  GetSimulationExport,
  GetSimulationExportReqParams,
  ReportOutputReq
} from '@gateway.Simulation'
import { yamadumiApi } from '../yamadumi-api'

export class SimulationExportGateway {
  static getSimulationExport = async (
    params: GetSimulationExportReqParams & ReportOutputReq
  ) => {
    return await yamadumiApi.get<GetSimulationExport>(
      '/api/report/yamadumi-simulation',
      {
        ...params,
        totalCostFrom: params.totalCostFrom !== null && params.totalCostFrom !== undefined ? params.totalCostFrom * 1000000 : params.totalCostFrom,
        totalCostTo: params.totalCostTo !== null && params.totalCostTo !== undefined ? params.totalCostTo * 1000000 : params.totalCostTo,
        ourCompanyTotalCostFrom: params.ourCompanyTotalCostFrom !== null && params.ourCompanyTotalCostFrom !== undefined ? params.ourCompanyTotalCostFrom * 1000000 : params.ourCompanyTotalCostFrom,
        ourCompanyTotalCostTo: params.ourCompanyTotalCostTo !== null && params.ourCompanyTotalCostTo !== undefined ? params.ourCompanyTotalCostTo * 1000000 : params.ourCompanyTotalCostTo
      }
    )
  }
}
